import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_1'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_1',
  name: 'Does the facility have any of the following safety measures in place for elevators?',
  description:
    'For elevator license, please refer to Category "Machinery and Equipment" question: Does the facility have legally required and up to date permits/ certificates/ licenses for the installation/ operation/ maintenance of special machines and equipment (…)?',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ELEVATORS_LIFTS_ARE_INSPECTED_REGULARLY',
      text: 'Elevators (lifts) are inspected regularly',
      externalIds: [
        {
          id: 'hs-12--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ELEVATOR_S_LOAD_CAPACITY_I_E_NUMBER_OF_PEOPLE_KG_LBS_IS_CLEARLY',
      text: "Elevator's load capacity (i.e. number of people/kg/lbs.) is clearly displayed in all elevators",
      externalIds: [
        {
          id: 'hs-12--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ALL_ELEVATORS_HAVE_A_SIGN_WARNING_AGAINST_THEIR_USE_IN_CASES_OF',
      text: 'All elevators have a sign warning against their use in cases of emergency (i.e. "Do not use elevator in cases of emergency")',
      externalIds: [
        {
          id: 'hs-12--1-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SAFETY_DEVICES_HAVE_BEEN_FITTED_ON_ELEVATOR_DOORS_TO_PREVENT_TH',
      text: 'Safety devices have been fitted on elevator doors to prevent them from opening unless the elevator is present',
      externalIds: [
        {
          id: 'hs-12--1-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ELEVATORS_ARE_WIRED_TO_BE_INOPERABLE_WHEN_ELEVATOR_DOORS_ARE_OP',
      text: 'Elevators are wired to be inoperable when elevator doors are open',
      externalIds: [
        {
          id: 'hs-12--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-12--1-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ELEVATORS_LIFTS_ARE_INSPECTED_REGULARLY',
                'ELEVATOR_S_LOAD_CAPACITY_I_E_NUMBER_OF_PEOPLE_KG_LBS_IS_CLEARLY',
                'ALL_ELEVATORS_HAVE_A_SIGN_WARNING_AGAINST_THEIR_USE_IN_CASES_OF',
                'SAFETY_DEVICES_HAVE_BEEN_FITTED_ON_ELEVATOR_DOORS_TO_PREVENT_TH',
                'ELEVATORS_ARE_WIRED_TO_BE_INOPERABLE_WHEN_ELEVATOR_DOORS_ARE_OP',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-9',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13960,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
